import React from "react";
import { FormGroup, Label, FormText } from "reactstrap";
import { DropdownFilter } from "../../generics/Filter";
import ConversionInput from "./ConversionInput";
import PropTypes from "prop-types";
import { UNIT_ERROR } from "./text";

const UnitError = ({ selectedDefaultUnit, handleChangeDefaultUnit, units, handleChangeConversionFactor, recoveryData }) => {
  return (
    <div>
      <FormGroup className="mt-1 ">
        <Label for="exampleFile">{`${UNIT_ERROR.DESCRIPTION} '${recoveryData.missing_unit}'`} </Label>
        <DropdownFilter dropdownVal={selectedDefaultUnit} onDropdownChange={handleChangeDefaultUnit} dropdownOptions={units} />
        <div class="col-12 col-sm-4">
          <FormText>{UNIT_ERROR.EXAMPLE}</FormText>
        </div>
      </FormGroup>
      <FormGroup className="mt-1 ">
        <Label for="exampleFile">{UNIT_ERROR.GUIDE(recoveryData.missing_unit, recoveryData.missing_unit_normalized_unit_display)}</Label>
        <ConversionInput
          handleChangeConversionFactor={handleChangeConversionFactor}
          missing_unit={recoveryData.missing_unit}
          normalized_unit={recoveryData.missing_unit_normalized_unit_display}
        />
      </FormGroup>
    </div>
  );
};

UnitError.propTypes = {
  selectedDefaultUnit: PropTypes.func,
  handleChangeDefaultUnit: PropTypes.func,
  units: PropTypes.object,
  handleChangeConversionFactor: PropTypes.func,
  recoveryData: PropTypes.object,
};

export default UnitError;
